module.exports = __webpack_public_path__ + "static/topography-977e3fd0f430205e51e65488c11fdddc.png";